import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    smartWorkoutData: {},
  },
  getters: {
    getSmartWorkoutData: state => {
      return state.smartWorkoutData;
    },
  },
  mutations: {
    setSmartWorkoutData(state, payload) {
      state.smartWorkoutData = payload;
    },
  }
});
